import { useLocation, Link } from "react-router-dom";
import styles from "./Breadcrumb.module.css";
import GlobalIcon from "../GlobalIcon/GlobalIcon";

function Breadcrumb() {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);

  // Map route paths to display names
  const routeNames = {
    "": "Welcome",
    "client-details": "Client Details",
    "trader-details": "Trader Details",
    "order-book": "Order Book",
    "trade-book": "Trade Book",
    "position-book": "Position Book",
    "holding-book": "Holding Book",
    "order-initiation": "Order Initiation",
    "order-initiate": "Order Initiate",
    "order-modification": "Order Modification",
    "order-status": "Order Status",
    "funds": "Funds",
    "client-health": "Client Health",
    "settings": "Settings",
    "strategy-report": "Strategy Report",
    "strategy-profiling": "Strategy Profiling",
  };

  // Build breadcrumb items
  const breadcrumbItems = [];

  // Always start with "Welcome" (home)
  breadcrumbItems.push({
    name: "Welcome",
    path: "/",
    isActive: pathnames.length === 0,
  });

  if (location.pathname === "/strategy-report") {
    breadcrumbItems.push(
      { name: "Dashboard", path: "/", isActive: false },
      { name: "Holdings", path: "/strategy-report", isActive: true }
    );
  } else {
    const isStrategyReportDetail =
      pathnames[0] === "strategy-report" && pathnames.length > 1;

    // Add other path segments
    let currentPath = "";
    pathnames.forEach((pathname, index) => {
      if (index > 0 && pathnames[index - 1] === "strategy-report") {
        return;
      }

      currentPath += `/${pathname}`;
      breadcrumbItems.push({
        name: routeNames[pathname] || pathname,
        path: currentPath,
        isActive: isStrategyReportDetail
          ? pathname === "strategy-report"
          : index === pathnames.length - 1,
      });
    });
  }

  return (
    <div className={styles["breadcrumb"]}>
      {breadcrumbItems.map((item, index) => (
        <div key={item.path} className={styles["breadcrumb-item"]}>
          <span
            className={`${styles["breadcrumb-separator"]} ${
              item.isActive ? styles["separator-active"] : ""
            }`}
          >
            <GlobalIcon iconName="BreadcrumbSeparator" className={styles["separator-icon"]} />
          </span>

          <Link
            to={item.path}
            className={`${styles["breadcrumb-link"]} ${
              item.isActive ? styles["breadcrumb-active"] : ""
            }`}
          >
            {item.name}
          </Link>
        </div>
      ))}
    </div>
  );
}

export default Breadcrumb;
